export function formatSeconds(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);

    if (seconds === 0) {
        return "--";
    }

    if (remainingSeconds === 0) {
        return `${String(minutes).padStart(2, "0")} min`;
    }

    if (minutes === 0) {
        return `${String(remainingSeconds).padStart(2, "0")} sec`;
    }

    return `${String(minutes).padStart(2, "0")} min ${String(remainingSeconds).padStart(2, "0")} sec`;
}